/* Cocina con Lola: galería, casillas de extras, total y botón de compra (enlace directo al checkout). */
(() => {
  // Moneda e idioma del mercado (los pone la cabecera); por defecto, euros en español.
  const buyForm = document.querySelector('[data-lola-buy]');
  const moneyLocale = (buyForm && buyForm.dataset.lolaLocale) || 'es-ES';
  const moneyCurrency = (buyForm && buyForm.dataset.lolaCurrency) || 'EUR';
  const euro = (cents) => {
    try { return (cents / 100).toLocaleString(moneyLocale, { style: 'currency', currency: moneyCurrency }); }
    catch (e) { return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  };

  document.querySelectorAll('[data-lola-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-lola-main]');
    gallery.querySelectorAll('[data-lola-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        main.src = btn.dataset.src;
        main.srcset = btn.dataset.srcset || '';
        main.alt = btn.dataset.alt || '';
        gallery.querySelectorAll('[data-lola-thumb]').forEach((b) => b.setAttribute('aria-current', b === btn ? 'true' : 'false'));
      });
    });
  });

  // Regalo con fecha real (ajustes de la cabecera): se ve y se añade al pedido solo hasta su fecha;
  // un descuento automático de Shopify lo deja a 0 € en el pago.
  const giftBox = document.querySelector('[data-lola-gift]');
  const giftEnd = giftBox ? Number(giftBox.dataset.end) * 1000 : 0;
  const giftOn = () => giftEnd > 0 && Date.now() < giftEnd;

  document.querySelectorAll('[data-lola-buy]').forEach((form) => {
    const base = Number(form.dataset.basePrice);
    const mainVariant = form.dataset.variant;
    const totalEls = document.querySelectorAll('[data-lola-total]');
    const boxes = () => [...form.querySelectorAll('input[data-bump]')];

    const refresh = () => {
      const extra = boxes().filter((b) => b.checked).reduce((sum, b) => sum + Number(b.dataset.price), 0);
      totalEls.forEach((el) => { el.textContent = euro(base + extra); });
    };
    boxes().forEach((b) => b.addEventListener('change', refresh));
    refresh();

    const go = (event) => {
      event.preventDefault();
      const gift = giftOn() && giftBox.dataset.variant ? [giftBox.dataset.variant] : [];
      const extras = boxes().filter((b) => b.checked).map((b) => b.value).filter((v) => !gift.includes(v));
      const items = [mainVariant, ...gift, ...extras].map((v) => `${v}:1`);
      document.querySelectorAll('[data-lola-cta]').forEach((b) => b.setAttribute('aria-busy', 'true'));
      // Sin fbq InitiateCheckout aquí: la app de Facebook ya lo envía desde el checkout; lanzarlo también aquí lo contaba dos veces.
      // Test A/B (snippets/lp-ab-split.liquid): marca el pedido de quien vio esta página dentro del test.
      let ab = '';
      try { if (localStorage.getItem('lola_ab_t1') === 'a') ab = '?attributes%5Bpagina%5D=A-actual'; } catch (e) {}
      window.location.href = `${form.dataset.cartUrl || '/cart'}/${items.join(',')}${ab}`;
    };
    form.addEventListener('submit', go);
    document.querySelectorAll('[data-lola-cta-proxy]').forEach((btn) => btn.addEventListener('click', go));
  });

  const sticky = document.querySelector('[data-lola-sticky]');
  const anchor = document.querySelector('[data-lola-cta]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const below = entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
    }).observe(anchor);
  }

  // Vídeos de la Crispi: se reproducen en silencio solo mientras se ven, para no gastar datos en el móvil.
  const reels = document.querySelectorAll('[data-lola-reel]');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reels.length && (still || !('IntersectionObserver' in window))) {
    reels.forEach((v) => { v.controls = true; v.preload = 'metadata'; });
  } else if (reels.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { target.play().catch(() => { target.controls = true; }); }
        else { target.pause(); }
      });
    }, { threshold: 0.5 });
    reels.forEach((v) => { v.muted = true; io.observe(v); });
  }

  // Oferta de lanzamiento con fecha real (ajustes de la cabecera). La cuenta atrás sale en la caja del precio,
  // en la barra de arriba, en la barra fija y debajo de cada botón, y todo se oculta solo al terminar.
  const launch = document.querySelector('[data-lola-launch]');
  if (launch) {
    const end = Number(launch.dataset.end) * 1000;
    const after = launch.dataset.after ? `${launch.dataset.afterLabel || ' · Después costará '}${launch.dataset.after}` : '';
    const leftLabel = launch.dataset.leftLabel || 'Quedan {clock}';
    const dayLabel = launch.dataset.day || 'd';
    document.querySelectorAll('[data-lola-after]').forEach((el) => { el.textContent = after; });
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      const on = end > 0 && left > 0;
      [launch, ...document.querySelectorAll('[data-lola-offer]')].forEach((el) => { el.hidden = !on; });
      if (!on) return false;
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const clock = `${d > 0 ? `${d} ${dayLabel} ` : ''}${pad(Math.floor(s / 3600) % 24)}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
      launch.querySelectorAll('[data-lola-countdown]').forEach((el) => { el.textContent = leftLabel.replace('{clock}', clock); });
      document.querySelectorAll('[data-lola-clock]').forEach((el) => { el.textContent = clock; });
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  }

  if (giftBox) {
    const leftLabel = giftBox.dataset.leftLabel || 'Quedan {clock}';
    const dayLabel = giftBox.dataset.day || 'd';
    document.querySelectorAll('[data-lola-gift-cta-text]').forEach((el) => { el.textContent = giftBox.dataset.cta || ''; });
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = giftEnd - Date.now();
      const on = left > 0;
      [giftBox, ...document.querySelectorAll('[data-lola-gift-show], [data-lola-gift-cta]')].forEach((el) => { el.hidden = !on; });
      // Mientras dura, el regalo va incluido: su casilla de extra de pago desaparece.
      document.querySelectorAll('[data-lola-gift-bump]').forEach((label) => {
        label.hidden = on;
        const input = label.querySelector('input');
        if (on && input && input.checked) { input.checked = false; input.dispatchEvent(new Event('change')); }
      });
      if (!on) return false;
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const clock = `${d > 0 ? `${d} ${dayLabel} ` : ''}${pad(Math.floor(s / 3600) % 24)}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}`;
      giftBox.querySelectorAll('[data-lola-gift-countdown]').forEach((el) => { el.textContent = leftLabel.replace('{clock}', clock); });
      document.querySelectorAll('[data-lola-gift-clock]').forEach((el) => { el.textContent = clock; });
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  }
})();
